export default __webpack_public_path__ + "static/media/avinode-blackbg.0cb8f715.png";